import React, { Fragment, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import Cookies from "js-cookie";
import { string, shape, func } from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  CardFooter,
  Collapse,
  Row,
  Col,
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import TranscriptTab from "./TranscriptTab";
import { VideoNote } from "../../../Shared/Notes/Notes";
import { SearchTarget } from "../../../Shared/SearchFilters";
import {
  fetchTranscript,
  getTranscripts,
  updateCopyTranscript,
} from "../VideoActions";
import {
  dateString,
  addDefaultSrc,
  getFilterSearchTranscript,
  abbreviateNumber,
} from "../../../utilities";
import DropboxPlayer from "../../../Shared/DropboxPlayer";
import GenerateTiktokThumbnail from "../../../Shared/GenerateTiktokThumbnail";

const brand_id = Cookies.get("bId");
const user_id = Cookies.get("uId");
const { REACT_APP_BASE_URL } = process.env;

const lodash = require("lodash");
const mainCard = {
  padding: "8px",
  margin: "8px 25px 8px 8px",
  borderRadius: "10px",
  border: "0.5px solid #dedee3",
};

const img = {
  borderRadius: "10px",
  display: "block",
  maxWidth: "100%",
  maxHeight: "100%",
};

const style = {
  width: "100%",
  height: "260px",
  objectFit: "contain",
  background: "black",
  borderRadius: "10px",
};

const link = {
  textDecoration: "underline",
  color: "#4b0c64",
};

const linkColor = {
  color: "#4b0c64",
};

const useStyles = {
  mainCard: {
    padding: "2px",
    margin: "auto",
    borderRadius: "10px",
  },
  collapse: {
    borderRadius: "10px",
  },
  img: {
    borderRadius: "10px",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  video_title: {
    textDecoration: "underline",
  },
  transcript: {
    borderRadius: "10px",
    padding: "7px",
    backgroundColor: "#dfffffbf",
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  collapseCard: {
    borderRadius: "10px",
  },

  link: {
    textDecoration: "underline",
    color: "#4b0c64",
  },
  linkColor: {
    color: "#4b0c64",
  },
  videoFrame: {
    borderRadius: "10px",
    backgroundColor: "black",
    height: "100%",
    position: "absolute",
    top: 0,
  },
};

const iconStyle = {
  marginRight: "5px",
};

export default function Transcript({
  video,
  transcript,
  search,
  note,
  handlePlayVideoSentence,
  totalVideo,
  toggleTranscript,
  keywordsSwitch,
}) {
  Transcript.propTypes = {
    video: shape({}).isRequired,
    search: string.isRequired,
    note: shape({}).isRequired,
    transcript: shape({}).isRequired,
    handlePlayVideoSentence: func.isRequired,
  };

  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);
  const [checked, setChecked] = useState(true);
  const [loadingFile, setLoadingFile] = useState(false);
  const [downloadDropdown, setDownloadDropdown] = useState(false);

  const navbarStatsReducer = useSelector((state) => state.navbarStatsReducer);
  const copyText = useSelector((state) => state.copyTranscriptReducer);

  const location = useLocation();
  const isAppManager = location.pathname === "/published";

  const classes = useStyles;

  const toggleDropdown = () => setDownloadDropdown(!downloadDropdown);

  const handleDownloadReport = (fileType) => {
    setLoadingFile(true);
    const body = {
      highlight: search,
      report_type: checked ? "keywords_only" : "all_transcripts",
      video_id: video._id,
      brand_id,
      user_id,
      // filters: selectedFilters, TODO: All Videos
    };
    //const csrfToken = document.querySelector('meta[name=csrf-token]').content;
    const headers = {
      // 'X-CSRF-Token': csrfToken,
      "Content-Type": "application/json",
    };
    const config = { method: "POST", body: JSON.stringify(body), headers };

    fetch(
      `${REACT_APP_BASE_URL}/jwt_api/videos/download_transcript_report.${fileType}`,
      config
    )
      .then((response) => response.blob())
      .then((blob) => URL.createObjectURL(blob))
      .then((url) => {
        // window.open(url, '_blank');
        const link = document.createElement("a");
        link.href = url;
        link.download = `transcript-report.${fileType}`;
        link.setAttribute("type", "hidden");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // For Firefox it is necessary to delay revoking the ObjectURL
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 100);
        setLoadingFile(false);
      })
      .catch((err) => {
        setLoadingFile(false);
        console.log(err);
      });
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  useEffect(() => {
    setExpanded(toggleTranscript);
  }, [toggleTranscript]);

  useEffect(() => {
    setChecked(keywordsSwitch);
  }, [keywordsSwitch]);

  const avgEngagement = () => {
    const { likes, youtube_dislike_count, comment_count } = video;
    const avgEng = (likes + youtube_dislike_count + comment_count) / totalVideo;
    return Math.round(avgEng);
  };

  const handleExpandClick = (id) => {
    if (!expanded) {
      if (transcript.video_id !== id) {
        dispatch(fetchTranscript([id]));
      }
    }
    setExpanded(!expanded);
  };

  const imageBlock = () => (
    <Row item sm={12} md={3} onClick={() => setExpanded(false)}>
      <Link to={`/videos/${video._id}`}>
        {video.platform === "Dropbox" && video.video_url ? (
          <div className="videoWrapper">
            <DropboxPlayer
              styleClass={classes.videoFrame}
              videoUrl={video.video_url}
            />
          </div>
        ) : (
          <img
            alt=""
            className={classes.img}
            src={video.thumbnail_url}
            onError={(event) => addDefaultSrc(event)}
            width="150"
            height={150}
          />
        )}
      </Link>

      <div style={{ border: "none", position: "absolute" }}>
        <VideoNote note={note} id={video._id} isFlagWithReason />
      </div>
    </Row>
  );

  const videoDetail = () => (
    <div className="d-flex align-content-start flex-wrap gap-1">
      <div>
        <i className="fa-regular fa-eye" style={iconStyle} />
        Views:
        {abbreviateNumber(video.youtube_view_count || video.view_count)}
      </div>
      <div>
        <i className="fa-regular fa-message" style={iconStyle} />
        Comments:
        {abbreviateNumber(video.comment_count)}
      </div>
      <div>
        <i className="fa-regular fa-thumbs-up" style={iconStyle} />
        Likes:
        {abbreviateNumber(video.likes)}
      </div>
      {video.platform !== "Tiktok" && (
        <div>
          <i className="fa-regular fa-thumbs-down" style={iconStyle} />
          Dislikes:
          {abbreviateNumber(video.youtube_dislike_count)}
        </div>
      )}
      <div>
        <i className="fa-solid fa-circle-nodes fa-sm" style={iconStyle} /> Avg
        Engagement:
        {abbreviateNumber(avgEngagement())}
      </div>
    </div>
  );

  const disableCopy =
    copyText.loading === video?._id || copyText.copied === video?._id;

  const copyTranscript = () => {
    if (disableCopy) {
      return;
    }
    dispatch(updateCopyTranscript({ loading: video?._id }));
    getTranscripts([video?._id])
      .then((data) => {
        let copiedTranscription = "";
        if (data.length && data[0].transcription?.length) {
          copiedTranscription = data[0].transcription
            .map((i) => i.content || "")
            .join("\r\n");
        }
        dispatch(
          updateCopyTranscript({
            loading: "",
            copied: video?._id,
            text: copiedTranscription,
          })
        );
        if (copiedTranscription.length) {
          const el = document.createElement("textarea");
          el.value = copiedTranscription;
          document.body.appendChild(el);
          el.select();
          document.execCommand("copy");
          document.body.removeChild(el);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getFilterTitle =
    search &&
    video?.title &&
    getFilterSearchTranscript(search, video?.title).map((text, index) => (
      <span key={index}>
        <SearchTarget search={search} text={text} /> [...]
        <br />
      </span>
    ));

  const expandTranscript = () => (
    <Row className="align-items-center">
      <Col lg={4} className="d-flex align-self-left ps-0 pe-0">
        {expanded && lodash.size(transcript.transcription) !== 0 ? (
          <FormGroup check>
            <Input
              id="checkbox2"
              type="checkbox"
              checked={checked}
              onChange={handleChange}
              style={{ fontSize: "15px" }}
            />{" "}
            <Label check>Keywords Only</Label>
          </FormGroup>
        ) : (
          ""
        )}
      </Col>
      <Col lg={4} className="ps-0">
        <span
          className={`${!disableCopy && "cursor-pointer"}`}
          onClick={copyTranscript}
          style={{ float: "right", color: "#783ad0" }}
        >
          {copyText.loading === video?._id
            ? "loading..."
            : copyText.copied === video?._id
            ? "Copied"
            : "Copy Full Transcript"}
        </span>
      </Col>
      <Col lg={4} className="ps-0">
        <span
          className="mb-0"
          style={{
            textDecoration: "underline",
            fontSize: 15,
            color: "red",
            cursor: "pointer",
          }}
          onClick={() => handleExpandClick(!expanded ? video._id : "")}
          aria-expanded={expanded}
          aria-label="show more"
        >
          {expanded ? "Hide " : "Show full "}
          transcript
        </span>
      </Col>
    </Row>
  );

  const getFilterSearch =
    search &&
    video?.transcription_text &&
    getFilterSearchTranscript(search, video?.transcription_text).map(
      (text, index) => (
        <span key={index}>
          <SearchTarget search={search} text={text} /> [...]
          <br />
        </span>
      )
    );

  const getSearchFromDecription =
    search &&
    video?.transcription_text &&
    getFilterSearchTranscript(search, video?.video_desc).map((text, index) => (
      <span key={index}>
        <SearchTarget search={search} text={text} /> [...]
        <br />
      </span>
    ));

  const CollapseSection = () => (
    <Collapse isOpen={expanded} timeout="auto" unmountOnExit>
      <Card className="transcriptVideosearchCard">
        <CardBody>
          <TranscriptTab
            handlePlayVideoSentence={handlePlayVideoSentence}
            search={search}
            transcript={transcript}
            checked={checked}
            video={video}
            productName={video?.product_names}
            brandName={navbarStatsReducer?.currentBrand?.name}
          />
        </CardBody>
        {lodash.size(transcript.transcription) !== 0 ? (
          <CardFooter>
            <ButtonDropdown
              className="py-0"
              style={{ float: "right" }}
              isOpen={downloadDropdown}
              toggle={toggleDropdown}
            >
              <DropdownToggle outline color="#000000">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={toggleDropdown}
                  disabled={loadingFile}
                >
                  <span className="d-flex justify-content-center align-items-center gap-1">
                    {loadingFile && <Spinner size="sm" />} Download Transcript
                  </span>
                </Button>
              </DropdownToggle>
              <DropdownMenu>
                {["txt", "pdf"].map((i) => (
                  <DropdownItem
                    className="w-100"
                    style={{ color: "#703dc8" }}
                    onClick={() => handleDownloadReport(i)}
                    key={i}
                  >
                    {i}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </ButtonDropdown>
          </CardFooter>
        ) : null}
      </Card>
    </Collapse>
  );

  return (
    <Fragment>
      <Card key={video.id} style={mainCard}>
        <Container>
          <Row>
            <Col lg="3">
              <Link
                target="_blank"
                rel="noopener noreferrer"
                to={`${isAppManager ? "/published/videos/" : "/videos/"}${
                  video._id
                }`}
              >
                {video.platform === "Dropbox" && video.video_url && (
                  <div className="videoWrapper" style={{ width: "285px" }}>
                    <DropboxPlayer
                      styleClass="videoFrame"
                      customStyles={{ borderRadius: "10px" }}
                      videoUrl={video.video_url}
                    />
                  </div>
                )}{" "}
                {video.platform === "Youtube" && video.video_url && (
                  <img
                    alt=""
                    style={img}
                    src={video.thumbnail_url}
                    onError={(event) => addDefaultSrc(event)}
                  />
                )}
                {video.platform === "Instagram" && video.video_url && (
                  <img
                    alt=""
                    style={style}
                    src={video.thumbnail_url}
                    onError={(event) => addDefaultSrc(event)}
                  />
                )}
                {(video?.platform === "Vyrill_AWS_S3" ||
                  video?.platform === "AWS_S3_Swirl") &&
                  video.video_url && (
                    <img
                      alt=""
                      style={style}
                      src={video.thumbnail_url}
                      onError={(event) => addDefaultSrc(event)}
                    />
                  )}
                {video?.platform === "GoogleDrive" && video.video_url && (
                  <img
                    alt=""
                    style={style}
                    src={video.thumbnail_url}
                    onError={(event) => addDefaultSrc(event)}
                  />
                )}
                {video.platform === "Tiktok" && video.video_url && (
                  <GenerateTiktokThumbnail
                    video={video}
                    customStyle={{
                      display: "flex",
                      justifyContent: "center",
                      background: "black",
                      borderRadius: "10px",
                    }}
                    imgStyle={{
                      maxHeight: "260px",
                      width: "100%",
                      borderRadius: "10px",
                      objectFit: "contain",
                    }}
                  />
                )}
              </Link>
              <div
                className={classes.iconFooter}
                style={{ border: "none", float: "right" }}
              >
                <VideoNote note={note} id={video._id} isFlagWithReason />
              </div>
            </Col>
            <Col lg="9" className="">
              <Row>
                <div style={{ textAlignLast: "right" }}>
                  {/* {video.platform === 'Dropbox' ? (
                <img
                  src="/assets/dropbox_icon.png"
                  alt="dropbox"
                  style={{ width: 'auto', height: 30 }}
                />
              ) : (
                <YouTubeIcon color="primary" />
              )} */}
                  Published:{" "}
                  {dateString(
                    video.youtube_published_at || video.published_at_on_platform
                  )}
                </div>
              </Row>
              <div>
                <div style={{ width: "100%" }}>
                  <div
                  // flexWrap="wrap"
                  // alignContent="flex-start"
                  >
                    <div className="mb-1">
                      <i className="icon-influencer" />
                      <img
                        src={
                          require(`@src/assets/images/vyrill/reports/video_icon.png`)
                            .default
                        }
                        style={{ marginRight: "5px" }}
                        width={18}
                      />
                      <Link
                        target="_blank"
                        rel="noopener noreferrer"
                        to={`${
                          isAppManager ? "/published/videos/" : "/videos/"
                        }${video._id}`}
                        style={link}
                      >
                        {video.title}
                        {getFilterTitle}
                      </Link>
                    </div>
                    <div className="mb-1">
                      <i className="far fa-user" />{" "}
                      <span style={linkColor}>{video.author}</span>
                    </div>
                    <div className="mb-1">
                      <i className="icon-product" />
                      <img
                        src={
                          require(`@src/assets/images/vyrill/reports/product_icon.png`)
                            .default
                        }
                        style={{ marginRight: "5px" }}
                        width={18}
                      />
                      <span style={linkColor}>{video.product_names}</span>
                    </div>
                  </div>
                  {videoDetail()}
                </div>
              </div>
              <Card className="videoTranscriptCard">
                <div className="p-1 d-flex justify-content-between">
                  <div style={{ width: "20%" }}>
                    <h5>Transcript:</h5>
                  </div>
                  <div className="text-end" style={{ width: "80%" }}>
                    {search && video?.transcription_text && expandTranscript()}
                  </div>
                </div>
                <Row item>
                  {!expanded && (
                    <div className="transcript" style={{ overflow: "hidden" }}>
                      {search && video?.transcription_text ? (
                        getFilterSearch && getFilterSearch?.length > 0 ? (
                          getFilterSearch
                        ) : (
                          getSearchFromDecription
                        )
                      ) : (
                        <p className="ps-1">
                          Transcripts are generated for videos with speech in
                          English.
                        </p>
                      )}
                    </div>
                  )}
                </Row>
                {CollapseSection()}
              </Card>
            </Col>
          </Row>
        </Container>
      </Card>
    </Fragment>
  );
}
